var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#011957"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5041 8.31552H16.0043V6.90526C16.0043 6.23377 15.458 5.6875 14.7865 5.6875H11.2133C10.5418 5.6875 9.99547 6.23377 9.99547 6.90526V8.31552H6.49566C5.60411 8.31552 4.87875 9.04087 4.87875 9.93242C4.87875 10.7423 4.79582 11.4696 5.40952 12.2875C5.75674 12.7502 6.23389 13.0803 6.78938 13.242L12.1835 14.8125C12.7175 14.968 13.2821 14.9681 13.8162 14.8125L19.2103 13.242C19.7658 13.0803 20.243 12.7502 20.5902 12.2875C21.2067 11.4659 21.1209 10.7311 21.1209 9.93242C21.121 9.04087 20.3957 8.31552 19.5041 8.31552ZM11.027 6.90526C11.027 6.80253 11.1105 6.71898 11.2133 6.71898H14.7865C14.8892 6.71898 14.9728 6.80256 14.9728 6.90526V8.31552H11.027V6.90526Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4988 14.2316C13.6806 15.9256 13.7559 15.9598 13 15.9598C12.2495 15.9598 12.4275 15.9571 6.5012 14.2316C5.87635 14.0496 5.32296 13.7143 4.87891 13.252V18.2016C4.87891 19.0932 5.60423 19.8185 6.49581 19.8185H19.5042C20.3958 19.8185 21.1211 19.0932 21.1211 18.2016V13.252C20.677 13.7142 20.1237 14.0496 19.4988 14.2316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/accountIcon.f50d6c555a3ad0837edb939b6562d204.svg";
export { ForwardRef as ReactComponent };